import { remove } from '@core/api/dicomApi';

const deleteStudy = async (studyInstanceUid: string): Promise<void> =>
  await remove(`/studies/${studyInstanceUid}`);

export default deleteStudy;
